<template>
  <div class="yw-dashboard">
    <iframe
      :src="src"
      frameborder="0"
      class="yw-dashboard-iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: 'YwDashboardPage',
  data() {
    return { src: 'https://dp.clousev.cn/#/release?releaseId=d13634d7ac444038bbc87d7f8f5f0289' }
  }
}
</script>
<style lang="stylus" scoped>
.yw-dashboard {
  width: 100%
  height: 100%

  .yw-dashboard-iframe {
    width: 100%
    height: 100%
  }
}
</style>
